
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFFFFF",
        "d": "M35.244,11.172h-22.49c-0.678,0-1.232,0.557-1.232,1.232L7.322,23.346c0,0.678,0.555,1.232,1.232,1.232\n\th2.674v11.014c0,0.682,0.555,1.236,1.234,1.236h6.781c0.682,0,1.234-0.555,1.234-1.236v-6.264h6.781v6.264\n\tc0,0.682,0.553,1.236,1.232,1.236h6.783c0.682,0,1.232-0.555,1.232-1.236V24.578h2.936c0.678,0,1.232-0.555,1.232-1.232\n\tl-4.199-10.941C36.477,11.729,35.922,11.172,35.244,11.172z M29.072,20.496c0,0.277-0.223,0.51-0.51,0.51h-2.721v2.725\n\tc0,0.275-0.229,0.502-0.514,0.502h-3.02c-0.275,0-0.5-0.227-0.5-0.502v-2.725h-2.723c-0.281,0-0.51-0.232-0.51-0.51v-3.021\n\tc0-0.281,0.229-0.51,0.51-0.51h2.723V14.25c0-0.285,0.225-0.512,0.5-0.512h3.02c0.285,0,0.514,0.227,0.514,0.512v2.715h2.721\n\tc0.287,0,0.51,0.229,0.51,0.51V20.496z"
      }
    }
  ]
})
    }
  